export default "__VITE_ASSET__DaoIXPKf__"